import { ReactNode } from 'react';

export const capitalized = (word: string) => word.charAt(0).toUpperCase() + word.slice(1);
export const mapToUpFirstSymbol = (children: ReactNode) =>
  typeof children === 'string' ? capitalized(children) : children;
